import { TicketXIcon } from 'lucide-react'

import { ActionRow } from '@/features/actions/components/action-row/ActionRow'
import { ActionRowBaseProps } from '@/features/actions/components/action-row/types'

export function UndelegateActionRow(props: ActionRowBaseProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={TicketXIcon} />
      <ActionRow.Title>Clear delegate</ActionRow.Title>
      <ActionRow.ErrorWarning />
      <ActionRow.Trigger>Undelegate</ActionRow.Trigger>
    </ActionRow>
  )
}
